import Axios from "../helpers/axios";

export const getAllCourses = () => {
  return Axios.get(`/courses`);
};

export const getDetailCourse = (course_id) => {
  return Axios.get(`/courses/${course_id}`);
};
